<template lang="pug">
  .lista-solicitud-vacaciones.contenedor-interno
    .title
      span Reporte de boletas

    transition(name="fade")
      .contenedor-frame(
        v-if="activateFrame"
        v-on-clickaway="cerrarFrame"
      )
        .titulo
          span.texto {{ tituloFrame }}
          .button(@click="cerrarFrame")
            span Cerrar
        iframe(
          :src="path"
        )
          | Oops! an error has occurred.

    transition(
      name='fade',
      tag="div",
      v-if="mostrarModalEliminar"
      )
      confirmar-accion-overlay(
        @close="closeModalEliminar"
        @do="eliminarBoleta"
        ref="confirmarEliminar"
      )
        span(slot="title") ¿Desea eliminar la boleta con periodo {{boletaEliminar.periodo}}, mes {{boletaEliminar.mes}}, tipo {{boletaEliminar.tipo}}, codigo {{boletaEliminar.codigo}}?
        span(slot="primaryAction")
          span(v-if="isProcessing") Eliminando...
          span(v-else) Eliminar
        strong Este proceso no se puede deshacer

    transition-group.contenedor-box-transition(name="fade-smooth-two", tag="div")
      .filtros-container(key="filtros-container")
        transition-group.contenedor-box-transition(name="fade-smooth-two", tag="div")
          .title-filtro(@click="mostrarFiltros = !mostrarFiltros",:class="{'hide-box-shadow': !mostrarFiltros}" , key="title-filtro")
            h2.text filtros
            .caret
              span.icon
                i.fa.fa-caret-down(v-if="mostrarFiltros")
                i.fa.fa-caret-up(v-else)

          .filtros(v-if="mostrarFiltros", key="filtros")
            .filtro
              .codigo-empleado
                .control.title-singular
                  p Codigo de empleado
                  .input-container
                    input.input(
                      type="number",
                      v-model="filtroCodigoEmpleado"
                      @focus="mostrarBusquedaEmpleado = true"
                    )
                    span.icon.cursor-pointer.margin-left-5(@click="mostrarBusquedaEmpleado = true")
                      i.fa.fa-search
                    .erase-data(@click="filtroCodigoEmpleado = ''")
                      .icon
                        .fa.fa-times
                transition(name="fade-quick")
                  .pop-over(
                      v-if="mostrarBusquedaEmpleado"
                    )
                      lookup-small-empleado(
                        @selected="seleccionarEmpleado"
                        @close="mostrarBusquedaEmpleado = false"
                        :codigo="filtroCodigoEmpleado"
                      )

            .filtro
              .title-singular
                p Año
              .select.display-flex
                select.flex-1(v-model='filtroPeriodo')
                  option(value="all") Todos
                  option(:value="o", v-for="o in periodos") {{o}}

            .filtro
              .title-singular
                p Mes
              .select.display-flex
                select.flex-1(v-model='filtroMes')
                  option(value="all") Todos
                  option(:value="o.codigo", v-for="o in meses") {{o.descripcion}}

            .filtro
              .title-singular
                p Tipo
              .select.display-flex
                select.flex-1(v-model='filtroTipo')
                  option(value="all") Todos
                  option(:value="o.codigo", v-for="o in tipos") {{o.descripcion}}

            .filtro
              .title-singular
                p ¿Visto?
              .select.display-flex
                select.flex-1(v-model='filtroVisto')
                  option(value="all") Todos
                  option(value="0") No vistas
                  option(value="1") Vistas

          .boton-container(key="boton-container")
            button.button(@click="fetch")
              span.icon.is-small
                i.fa.fa-refresh.fa-fw.fa-lg
              span Refrescar
            button.button(@click="limpiarFiltros")
              span.icon.is-small
                i.fa.fa-trash.fa-fw.fa-lg
              span Limpiar
            button.button.is-primary.margin-button-top(@click="openModalNotificacionMasiva")
              span.icon.is-small
                i.fa.fa-envelope.fa-fw.fa-lg
              span Notificar a todos los filtrados
      .body(key="body")
        .is-loading(v-if="isLoading")
          .icon
            i.fa.fa-spinner.fa-spin
        .information(v-else)
          table.table.is-striped.is-bordered(
            v-if="lista.length !== 0"
          )
            thead
              //- th Id
              th Empleado
              th.hide-break-1 Periodo
              th.hide-break-1 Mes
              th Tipo
              th.hide-break-1 Visto
              th
            tbody(
              name="table-row"
              is="transition-group"
            )
              tr.row-table(
                v-for="(o, index) in lista"
                :key="index"
              )
                td
                  .td-wrapper
                    span.hint--top(:aria-label="'Empleado: ' + o.dni") {{ o.nombre }}
                    .show-break-1.dates-wrapper
                      span.has-text-bold Periodo:&nbsp;
                      span {{ o.periodo }} - {{ o.nombreMes }}
                    template(v-if="o.visto")
                      .show-break-1.seen
                        span.has-text-bold Visto
                        span.icon
                          i.fa.fa-check.fs-12
                td.hide-break-1 {{ o.periodo }}
                td.hide-break-1 {{ o.nombreMes }}
                td {{ o.descripcionTipo }}
                td.text-align-center.hide-break-1
                  template(v-if="o.visto")
                    span.icon
                      i.fa.fa-check
                  template(v-else)
                    span
                td.text-center
                  .contenedor-acciones
                    button.button.is-small(
                      @click="verPdf(o)"
                    )
                      span.icon.is-small
                        i.fa.fa-eye.fs-12
                      span Ver pdf
                    button.button.is-small.margin-left-5(
                      @click="notificar(o)"
                      v-if="!o.visto"
                      title="'Enviar mail al empleado para que vea su boleta'"
                    )
                      span.icon.is-small
                        i.fa.fa-envelope.fs-12
                      span Notificar
                    button.button.is-small.is-danger.ml-5(@click="confirmacionEliminar(o)")
                      span.icon.is-small
                        i.fa.fa-trash.fs-12
                      span Eliminar
          div(v-else)
            .message.is-warning
              .message-body No hay boletas que cumplan con los siguientes filtros

    transition(name='fade', v-if="mostrarNotificacionMasiva")
      .modal(:class="{'is-active' : mostrarNotificacionMasiva}")
        .modal-background
        .card(v-on-clickaway="closeModalNotificacionMasiva")
          header.card-header
            p.card-header-title
              span Notificacion
            a.card-header-icon
              span.icon
                button.delete(@click="closeModalNotificacionMasiva")
          .card-content
            .content
              strong ¿ Esta seguro de notificar a todos los empleados filtrados?
          footer.card-footer
            button.button.card-footer-item.is-primary.is-outlined.info-box-button(
            @click="notificacionMasiva()",
            :disabled="isLoading",
            :class="{'is-loading' : isLoading}")
              span Notificar a todos los filtrados
            button.button.card-footer-item.is-primary.is-outlined.info-box-button(
            @click="closeModalNotificacionMasiva",
            :disabled="isLoading"
            ) Cancelar

    transition(name='fade', v-if="mostrarObservaciones")
      .modal(:class="{'is-active' : mostrarObservaciones}")
        .modal-background
        .card
          header.card-header
            p.card-header-title
              span Observaciones encontradas
            a.card-header-icon
              span.icon
                button.delete(@click="closeModalObservaciones")
          .card-content.card-content-observaciones-max-height
            .content.has-text-left
              div(v-if="observaciones.length > 0" v-for="o in observaciones")
                strong {{o}}
          footer.card-footer
            button.button.card-footer-item.is-primary.is-outlined.info-box-button(
            @click="closeModalObservaciones",
            :disabled="isLoading"
            ) Cancelar
</template>

<script>
import LookupSmallEmpleado from './Component_Lookup_Small_Empleado.vue'
import { apiGet, apiPost, apiDelete, notify } from '../util/general'
import ConfirmarAccionOverlayComponent from '../components/Component_Confirmar_Accion_Overlay'
import { scrollTo } from '../util/scroll'
export default {
  name: 'lista_boletas_reporte_component',
  data () {
    return {
      lista                     : [],
      isLoading                 : false,
      mostrarBusquedaEmpleado   : false,
      mostrarFiltros            : true,
      mostrarNotificacionMasiva : false,
      mostrarObservaciones      : false,
      solicitudSeleccionada     : {},
      filtroCodigoEmpleado      : '',
      filtroTipo                : '',
      filtroMes                 : 'all',
      filtroPeriodo             : '',
      filtroVisto               : '',
      tipos                     : [],
      observaciones             : [],
      meses                     : [
        { codigo: 1, descripcion: 'Enero' },
        { codigo: 2, descripcion: 'Febrero' },
        { codigo: 3, descripcion: 'Marzo' },
        { codigo: 4, descripcion: 'Abril' },
        { codigo: 5, descripcion: 'Mayo' },
        { codigo: 6, descripcion: 'Junio' },
        { codigo: 7, descripcion: 'Julio' },
        { codigo: 8, descripcion: 'Agosto' },
        { codigo: 9, descripcion: 'Setiembre' },
        { codigo: 10, descripcion: 'Octubre' },
        { codigo: 11, descripcion: 'Noviembre' },
        { codigo: 12, descripcion: 'Diciembre' }
      ],
      periodos      : [],
      path          : '',
      activateFrame : false,
      boletaEliminar : {},
      mostrarModalEliminar: false,
      isProcessing: false
    }
  },
  components: {
    LookupSmallEmpleado,
    'confirmar-accion-overlay': ConfirmarAccionOverlayComponent
  },
  created () {
    this.limpiarFiltros()
    this.loadPeriodos()
    this.fetchTipos()
    this.filtroVisto = this.$route.query.visto || 'all'
    this.filtroTipo           = this.$route.query.tipo || 1
    this.filtroMes            = this.$route.query.mes || +window.moment().format('MM')
    this.filtroPeriodo        = this.$route.query.anio || +window.moment().format('YYYY')
    this.filtroCodigoEmpleado = this.$route.query.codigoEmpleado || ''
    this.fetch()
  },
  watch : {
    filtroCodigoEmpleado (value) {
      return this.fetch()
    },
    filtroTipo (value) {
      return this.fetch()
    },
    filtroMes (value) {
      return this.fetch()
    },
    filtroPeriodo (value) {
      return this.fetch()
    },
    filtroVisto (value) {
      return this.fetch()
    }
  },
  methods: {
    loadPeriodos () {
      var vm = this
      var periodoInicial = 2018
      var periodoActual = +window.moment().format('YYYY')
      vm.filterPeriodo = periodoActual

      while (periodoActual >= periodoInicial) {
        vm.periodos.push(periodoActual)
        periodoActual--
      }
    },
    fetchTipos () {
      var vm = this
      var obj = {
      }
      apiGet(vm, '/boleta/tipos', obj, function (data) {
        vm.tipos = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
      })
    },
    fetch () {
      var vm = this
      vm.isLoading = true

      var filtros = {
        periodo        : vm.filtroPeriodo,
        mes            : vm.filtroMes,
        tipo           : vm.filtroTipo,
        codigoEmpleado : vm.filtroCodigoEmpleado,
        visto          : vm.filtroVisto
      }

      if (filtros.visto !== 'all') {
        filtros.visto = +filtros.visto
      }

      var obj = {
        filtros: filtros
      }
      apiGet(vm, '/boleta/reporte', obj, function (data) {
        vm.lista = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    seleccionarEmpleado (o) {
      this.filtroCodigoEmpleado = o.codigo
    },
    limpiarFiltros () {
      this.filtroTipo           = 1
      this.filtroCodigoEmpleado = ''
      this.filtroMes            = +window.moment().format('MM')
      this.filtroPeriodo        = +window.moment().format('YYYY')
      this.filtroVisto          = 'all'
    },
    verPdf (boleta) {
      var vm = this
      // Obtener path enviando los datos
      vm.tituloFrame = 'Boleta de ' + boleta.nombreMes + ' ' + boleta.periodo + ' - ' + boleta.descripcionTipo
      vm.activateFrame = true
      var token = localStorage.getItem('token')
      this.path = process.env.API_ROUTE + '/boleta/empleado/pdf?token=' + token + '&empresa=' + process.env.EMPRESA + '&codigo=' + boleta.codigo + '&periodo=' + boleta.periodo + '&mes=' + boleta.mes + '&tipo=' + boleta.tipo
      // this.path = process.env.API_ROUTE + '/boleta/empleado/pdf?token=' + token + '&empresa=' + process.env.EMPRESA + '&periodo=' + boleta.periodo + '&mes=' + boleta.mes + '&tipo=' + boleta.tipo
      // Scroll top
      // document.body.scrollTop = 0; // For Safari
      // document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
    cerrarFrame () {
      this.path = ''
      this.activateFrame = false
    },
    notificar (o) {
      var vm = this

      var obj = {
        periodo : o.periodo,
        mes     : o.mes,
        tipo    : o.tipo,
        codigo  : o.codigo
      }

      apiPost(vm, '/boleta/empleado/notificar', obj, function (data) {
        notify(vm, 'success', 'Éxito', 'Se le notifico al empleado')
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      })
    },
    openModalNotificacionMasiva () {
      this.mostrarNotificacionMasiva = true
    },
    closeModalNotificacionMasiva () {
      this.mostrarNotificacionMasiva = false
    },
    notificacionMasiva () {
      var vm = this
      vm.isLoading     = true
      vm.observaciones = []

      var filtros = {
        periodo        : vm.filtroPeriodo,
        mes            : vm.filtroMes,
        tipo           : vm.filtroTipo,
        codigoEmpleado : vm.filtroCodigoEmpleado,
        visto          : vm.filtroVisto
      }

      if (filtros.visto !== 'all') {
        filtros.visto = +filtros.visto
      }

      var obj = {
        filtros: filtros
      }
      apiPost(vm, '/boleta/notificar/filtrados', obj, function (data) {
        vm.closeModalNotificacionMasiva()
        if (data.observaciones.length > 0) {
          notify(vm, 'success', 'Éxito', 'Se notifico correctamente pero hay algunas observaciones.')
          vm.observaciones        = data.observaciones
          vm.mostrarObservaciones = true
        } else {
          notify(vm, 'success', 'Éxito', 'Se notifico correctamente a todos.')
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    closeModalObservaciones () {
      var vm = this
      vm.observaciones        = []
      vm.mostrarObservaciones = false
    },
    confirmacionEliminar (o) {
      var vm = this
      vm.boletaEliminar = {
        periodo : o.periodo,
        mes     : o.mes,
        tipo    : o.tipo,
        codigo  : o.codigo
      }
      vm.mostrarModalEliminar = true
      this.$nextTick(() => {
        scrollTo({
          ref: this.$refs.confirmarEliminar.$el,
          vm: this,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        })
      })
    },
    eliminarBoleta () {
      var vm = this

      if (!vm.isProcessing) {
        vm.isProcessing = true
        var obj = {
          periodo : vm.boletaEliminar.periodo,
          mes     : vm.boletaEliminar.mes,
          tipo    : vm.boletaEliminar.tipo,
          codigo  : vm.boletaEliminar.codigo
        }
        apiDelete(vm, '/boleta/eliminar', obj, function (data) {
          notify(vm, 'success', 'Éxito', 'Se elimino boleta exitosamente')
          vm.isProcessing = false
          vm.boletaEliminar = {}
          vm.fetch()
          vm.mostrarModalEliminar = false
        }, function (error) {
          notify(vm, 'error', 'Error', error.message)
          vm.isProcessing = false
        })
      }
    },
    closeModalEliminar () {
      var vm = this
      vm.boletaEliminar        = []
      vm.mostrarModalEliminar = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .fs-12
    font-size 12px
  .contenedor-interno
    .close
      position absolute
      top 3px
      right 3px
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      span
        font-weight bold
        text-transform uppercase

  th
    text-align center

  .row-table
    transition all 0.3s ease
    &.is-close
      background-color #ffd6d6 !important


  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }

  .pop-over
    background: #fff;
    border-radius: 3px;
    border: 1px solid #d6dadc;
    border-bottom-color: #c4c9cc;
    -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
    box-shadow: 0 1px 6px rgba(0,0,0,.15);
    position: absolute;
    min-width: 300px
    width: 100%;
    z-index: 70;
    top 0

  .position-relative
    position relative

  .codigo-empleado
    position relative
    .control
      .input-container
        display flex
        align-items center
        .input
          flex 1
          width 100px
        .erase-data
          cursor pointer
          margin-left 5px

  .filtros-container
    padding-bottom 10px
    border-bottom 1px solid #ccc
    .title-filtro
      display flex
      text-align left
      padding 10px
      margin-bottom 10px
      border-bottom 1px solid #ccc
      .text
        text-transform uppercase
        flex 1
      .caret
        cursor pointer

    .filtros
      margin-bottom 10px
      text-align left
      display flex
      align-items: flex-start;


      .filtro
        // width 100%
        display inline-block
        border 1px solid #cccccc
        background-color #f9f9f9
        padding 5px
        margin 5px
        border-radius 3px
        flex 1
        .title-singular
          text-align left
          font-weight bold
          user-select: none
        .abierto-cerrado-container
          display flex
          .option
            padding 4px
            border 1px solid #565cde
            color #565cde
            cursor pointer
            transition all 0.3s ease
            height 31.5px

            &.selected
              background-color: #565cde;
              color: #fff;

        .list-container
          padding 0px 10px 0px 10px
          .option
            user-select: none
            cursor pointer
            &.selected
              color #565cde
              font-weight bold

  .boton-container
    button
      margin-left 5px

  .contenedor-acciones
    display flex
    flex-wrap: wrap;
    .button
      flex 1
      margin 3px 5px

  .is-loading
    margin-top 10px

  .button.is-loading
    margin-top 0px

  .information
    padding-top 10px

  td
    vertical-align: middle;

  is-close
    background-color: #ffd6d6 !important;

  .text-align-center
    text-align center

  .contenedor-frame
    position fixed
    background-color #ccc
    left 1
    top: 0px;
    left: 0px;
    width: 100%;
    height 100vh;
    padding 20px
    transition all 0.5s ease
    z-index: 9999

    .titulo
      display flex
      align-items center
      .texto
        flex 1
        text-align left
        font-size 25px
      .button
        margin-bottom 10px

    iframe
      width 100%
      height calc(100% - 30px);

  .card-footer-item:not(:last-child)
    border-right: 1px solid #dbdbdb
  .info-box-button
    border-radius 0
    border        0px

  .show-break-1
    display none
  @media (max-width: 1035px)
    .filtros
      flex-direction column
      .filtro
        width 100%

  @media (max-width: 650px)
    .show-break-1
      display initial
    .hide-break-1
      display none
    .table
      font-size 12px
      td
        text-align: center
        vertical-align: middle
      .td-wrapper
        display flex
        justify-content: center
        align-items: center
        flex-direction: column

        .dates-wrapper
          display: flex
          flex-direction: column
        .seen
          background-color: #94b3e9;
          padding: 0px 4px;
          margin-top: 3px;
          border-radius: 4px;
  @media (max-width: 520px)
    .boton-container
      .margin-button-top
        margin-top 5px
</style>



// WEBPACK FOOTER //
// Component_Boletas_Reporte_Lista.vue?640475a2